<template>
  <div class="antialiased text-white">
    <main class="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
      <div class="hidden lg:flex items-center justify-center bg-black p-8">
        <img src="/images/Frame.png" alt="OverX PDV Logo" class="w-full max-w-sm" />
      </div>

      <div class="bg-overx-orange flex flex-col justify-center p-8 sm:p-12">
        <div class="max-w-2xl mx-auto w-full">
          
          <div>
            <h1 class="font-extrabold text-black text-4xl md:text-5xl tracking-tight">Over PDV</h1>
            <p class="mt-3 text-base text-white/90">
              Sistema completo de ponto de venda que integra todas as operações do seu negócio em uma única plataforma, aumentando eficiência e reduzindo custos.
            </p>
          </div>

          <div class="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div v-for="feature in features" :key="feature.title" class="bg-black/90 rounded-lg p-3">
              <h3 class="font-bold text-sm">{{ feature.title }}</h3>
              <p class="mt-1 text-xs text-white/70">{{ feature.description }}</p>
            </div>
          </div>

          <div class="mt-10">
            <div class="flex items-baseline space-x-3">
              <h2 class="text-lg font-bold">Resultados comprovados:</h2>
              <span class="text-xl font-extrabold tracking-tight">+85% em produtividade</span>
            </div>
            
            <div class="mt-3">
              <div class="w-full bg-white/20 rounded-full h-2">
                <div class="bg-gray-200 h-2 rounded-full" style="width: 85%"></div>
              </div>
              <div class="flex justify-between text-xs font-medium text-white/80 mt-2">
                <span>Antes da implementação</span>
                <span>Depois da implementação</span>
              </div>
            </div>
          </div>

          <div class="mt-12">
            <a href="#" class="block w-full max-w-md mx-auto text-center bg-black text-white font-bold uppercase py-3 px-8 rounded-full text-base hover:bg-gray-800 hover:scale-105 transition-all duration-300">
              Quero conhecer o Over PDV
            </a>
          </div>

        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const features = ref([
  {
    title: 'Funcionalidades',
    description: 'Qr code na mesa, impressão rápida, abertura e fechamento de caixa, integração com whatsapp, chatbot, tempo de solicitação da mesa.'
  },
  {
    title: 'Relatórios',
    description: 'Análises detalhadas para decisões estratégicas.'
  },
  {
    title: 'Integrações',
    description: 'Conecte com o ifood e seu negócio.'
  }
]);
</script>

<style scoped>
/* A classe `text-white/90` usa a opacidade do Tailwind para um branco levemente transparente. */
/* O `antialiased` na div principal melhora a renderização da fonte. */
</style>